"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'channelDevelopment',
      searchQuery: {
        type: '1',
        value: curDateTree.month,
        srEmpName: ''
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        // srEmpNo: {
        //   label: this.$t("sfe.channelDevelopment.srEmpNo"),
        //   valueKey: "srEmpNo"
        // },
        srEmpName: {
          label: this.$t('sfe.channelDevelopment.srEmpName'),
          valueKey: 'srEmpName'
        },
        value: {
          label: this.$t('common.month'),
          valueKey: 'value',
          inputType: 'date',
          type: 'month',
          valueFormat: 'yyyyMM'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.channeldevelopment'),
          apiUrl: '/protected/pc/report/sr/channelDevelopment/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        // srEmpNo: {
        //   label: this.$t("sfe.channelDevelopment.srEmpNo")
        // },
        rsmName: {
          label: this.$t('sfe.channelDevelopment.rsmName'),
          fixed: 'left'
        },
        asmName: {
          label: this.$t('sfe.channelDevelopment.asmName'),
          fixed: 'left'
        },
        srEmpName: {
          label: this.$t('sfe.channelDevelopment.srEmpName'),
          fixed: 'left'
        },
        tppStoreTargetYtd: {
          label: this.$t('sfe.channelDevelopment.tppStoreTargetYtd')
        },
        tppSignedYtd: {
          label: this.$t('sfe.channelDevelopment.tppSignedYtd')
        },
        visitBailianStore: {
          label: this.$t('sfe.channelDevelopment.visitBailianStore')
        },
        newSefStore: {
          label: this.$t('sfe.channelDevelopment.newSefStore')
        },
        newRegisterQty: {
          label: this.$t('sfe.channelDevelopment.newRegisterQty')
        },
        newRegisterConfirmedQty: {
          label: this.$t('sfe.channelDevelopment.newRegisterConfirmedQty')
        },
        newSignQty: {
          label: this.$t('sfe.channelDevelopment.newSignQty')
        },
        newSignConfirmedQty: {
          label: this.$t('sfe.channelDevelopment.newSignConfirmedQty')
        },
        activeStore: {
          label: this.$t('sfe.channelDevelopment.activeStore')
        },
        oneYearExpiredGasnStore: {
          label: this.$t('sfe.channelDevelopment.oneYearExpiredGasnStore')
        },
        halfYearExpiredGasnStore: {
          label: this.$t('sfe.channelDevelopment.halfYearExpiredGasnStore')
        },
        overdueGasnStore: {
          label: this.$t('sfe.channelDevelopment.overdueGasnStore')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/pc/report/sr/channelDevelopment/list'
      };
    }
  }
};